import React from 'react'
import axios from 'axios';
import utils from '../../Utils';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'

import style from 'style/consult/ConsultHistoryItem.css'

class ConstultHistoryItem extends React.Component {
  componentDidMount() {

  }
  fullName = (patient) => {
    return patient.fname + ((patient.lname && patient.fname) && ' ') + patient.lname
  }
  showQuiz = (quizId) => {

  }
  render() {
    return (
      <div class="consult-history-item card">
        <div class='c-h-image-section'>
          <img src={utils.doctorImageUrl(this.props.consultRequest.doctor.url)} />
          <div class='cs-showQuiz'>
            <Link to={'/quiz/' + this.props.consultRequest.id} className='test-link'>نمایش تست</Link>
          </div>
        </div>
        <div class='c-h-info'>
          <div class='kv-row'>
            <div class='kv-label'>مشاور</div>
            <div class='kv-value bold'>{this.fullName(this.props.consultRequest.doctor)}</div>
          </div>
          <div class='kv-row'>
            <div class='kv-label'>عنوان سوال</div>
            <div class='kv-value'>{this.props.consultRequest.question}</div>
          </div>
          <div class='kv-row'>
            <div class='kv-label'>دسته بندی</div>
            <div class='kv-value'>{this.props.consultRequest.ConsultCategory.name}</div>
          </div>
          <div >
            <div class='kv-label'>تشخیص پزشک</div>
            <div class=''>{this.props.consultRequest.finalDiagnosis || 'مشاوره پایان نیافته است'}</div>
          </div>

        </div>
      </div>
    )
  }
}
export default ConstultHistoryItem;